import React, { useState } from 'react';
import { Table, Button, Space, Input, Modal, Form, Col, Row, message } from 'antd';
import { EyeOutlined, EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import '../Styles/Personnels.css'
const { Search } = Input;

const ClientList = () => {
  const [personnels, setClients] = useState([
    {
      key: '1',
      nom: 'FAYE',
      prenom: 'Cheikh',
      cin: '123456789',
      cnss:'3939',
      phone: '770100101',
      address: 'Dakar',
      email: 'latyrgbs@business.com',
    },
    {
      key: '2',
      nom: 'DIOP',
      prenom: 'Seydou',
      cin: '123456789',
      cnss:'3939',
      phone: '338900102',
      address: 'Diamniadio',
      email: 'Sonacos@tech.com',
    },
    {
        key: '3',
        nom: 'SALL',
        prenom: 'Oulimatou',
        cin: '123456789',
        cnss:'3939',
        phone: '339900102',
        address: 'Thies',
        email: 'ouly@tech.com',
      },
      {
        key: '4',
        nom: 'GAYE',
        prenom: 'Marieme',
        cin: '123456789',
        cnss:'3030',
        phone: '701230102',
        address: 'St-Louis',
        email: 'mariemgaye@tech.com',
      },
  ]);

  // States pour gérer les modals
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedPersonnels, setSelectedClient] = useState(null); // Stocke le client sélectionné pour voir/modifier

  const [form] = Form.useForm();

  // Ouvrir le modal d'ajout
  const showModal = () => {
    setIsModalVisible(true);
  };

  // Fermer le modal d'ajout
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // Ajouter un client
  const handleOk = () => {
    form.validateFields().then((values) => {
      form.resetFields();
      const newPersonnels = { ...values, key: personnels.length + 1 };
      setClients([...personnels, newPersonnels]);
      message.success('Client ajouté avec succès !');
      setIsModalVisible(false);
    });
  };

  // Ouvrir le modal pour voir les détails du client
  const handleViewClient = (personnel) => {
    setSelectedClient(personnel);
    setIsViewModalVisible(true);
  };

  // Fermer le modal de vue
  const handleViewCancel = () => {
    setIsViewModalVisible(false);
  };

  // Ouvrir le modal d'édition
  const handleEditClient = (personnel) => {
    setSelectedClient(personnel);
    form.setFieldsValue(personnel); // Pré-remplit le formulaire avec les données du client
    setIsEditModalVisible(true);
  };

  // Fermer le modal d'édition
  const handleEditCancel = () => {
    setIsEditModalVisible(false);
  };

  // Modifier un client
  const handleEditOk = () => {
    form.validateFields().then((values) => {
      const updatedPersonnels = personnels.map((personnel) =>
        personnel.key === selectedPersonnels.key ? { ...personnel, ...values } : personnel
      );
      setClients(updatedPersonnels);
      message.success('Client modifié avec succès !');
      setIsEditModalVisible(false);
    });
  };

  // Supprimer un client
  const handleDeleteClient = (key) => {
    const updatedPersonnels = personnels.filter((personnel) => personnel.key !== key);
    setClients(updatedPersonnels);
    message.success('Personnel supprimé avec succès !');
  };

  // Colonnes du tableau
  const columns = [
    { title: 'Nom', dataIndex: 'nom', key: 'nom' },
    { title: 'Prénom', dataIndex: 'prenom', key: 'prenom' },
    { title: 'CIN', dataIndex: 'cin', key: 'cin' },
    { title: 'Numéro CNSS', dataIndex: 'cnss', key: 'cnss' },
    { title: 'Téléphone', dataIndex: 'phone', key: 'phone' },
    { title: 'Adresse', dataIndex: 'address', key: 'address' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, personnel) => (
        <Space size="middle">
          <Button icon={<EyeOutlined />} onClick={() => handleViewClient(personnel)} className='open-button' />
          <Button icon={<EditOutlined />} onClick={() => handleEditClient(personnel)} className='edit-button' />
          <Button
            icon={<DeleteOutlined />}
            onClick={() => handleDeleteClient(personnel.key)}
            className='delete-button'
          />
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Search placeholder="Rechercher un client" style={{ width: 300 }} />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            shape="circle"
            style={{ background: '#2c8267', borderColor: '#2c8267' }}
            onClick={showModal}
          />
      </div>
      
      <Table
        columns={columns}
        dataSource={personnels}
        pagination={{ pageSize: 10 }}
        rowClassName={(record, index) => (index % 2 === 0 ? 'even-row' : 'odd-row')}
        className="personnels-table"
        
      />

      {/* Modal d'ajout */}
      <Modal
        title="Ajouter un client"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Ajouter"
        cancelText="Annuler"
      >
        <Form form={form} layout="vertical" name="client_form">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="company"
                label="Raison sociale"
                rules={[{ required: true, message: 'Veuillez entrer la raison sociale' }]}
              >
                <Input placeholder="Nom de la société" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="fiscal"
                label="Matricule fiscale"
                rules={[{ required: true, message: 'Veuillez entrer le matricule fiscale' }]}
              >
                <Input placeholder="Matricule fiscale" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="trade"
                label="Registre de commerce"
                rules={[{ required: true, message: 'Veuillez entrer le registre de commerce' }]}
              >
                <Input placeholder="Registre de commerce" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="phone"
                label="Téléphone"
                rules={[{ required: true, message: 'Veuillez entrer le numéro de téléphone' }]}
              >
                <Input placeholder="Téléphone" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="address"
                label="Adresse"
                rules={[{ required: true, message: 'Veuillez entrer l’adresse' }]}
              >
                <Input placeholder="Adresse" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: 'Veuillez entrer l’email' }]}
              >
                <Input placeholder="Email" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      {/* Modal pour voir les détails d'un client */}
      <Modal
        title="Détails du personnel"
        visible={isViewModalVisible}
        onCancel={handleViewCancel}
        footer={null}
      >
        {selectedPersonnels && (
          <div>
            <p><strong>Nom : </strong>{selectedPersonnels.nom}</p>
            <p><strong>Prénom : </strong>{selectedPersonnels.prenom}</p>
            <p><strong>CIN : </strong>{selectedPersonnels.cin}</p>
            <p><strong>Numéro CNSS : </strong>{selectedPersonnels.cnss}</p>
            <p><strong>Téléphone : </strong>{selectedPersonnels.phone}</p>
            <p><strong>Adresse : </strong>{selectedPersonnels.address}</p>
            <p><strong>Email : </strong>{selectedPersonnels.email}</p>
          </div>
        )}
      </Modal>

      {/* Modal pour modifier un client */}
      <Modal
        title="Modifier un client"
        visible={isEditModalVisible}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
        okText="Modifier"
        cancelText="Annuler"
      >
        <Form form={form} layout="vertical" name="edit_client_form">
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="nom"
                label="Nom"
                rules={[{ required: true, message: 'Veuillez entrer votre nom' }]}
              >
                <Input placeholder="Votre nom" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="prenom"
                label="Prénom"
                rules={[{ required: true, message: 'Veuillez entrer votre prénom' }]}
              >
                <Input placeholder="Votre prénom" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="cin"
                label="CIN"
                rules={[{ required: true, message: 'Veuillez entrer votre cin' }]}
              >
                <Input placeholder="CIN" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="phone"
                label="Téléphone"
                rules={[{ required: true, message: 'Veuillez entrer le numéro de téléphone' }]}
              >
                <Input placeholder="Téléphone" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="address"
                label="Adresse"
                rules={[{ required: true, message: 'Veuillez entrer l’adresse' }]}
              >
                <Input placeholder="Adresse" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: 'Veuillez entrer l’email' }]}
              >
                <Input placeholder="Email" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default ClientList;
